import { InversionContainer } from '@/controller/container'
import { InjectionTokens } from '@/controller/tokens'

import { UseCase } from '@/domain/core/UseCase'
import { Result } from '@/domain/protocols/Result'

import { UserChartSyncService } from '@/services/userChartSync/UserChartSyncService'

interface SyncRunner {
  sync(): Promise<Result<void>>
}

export class RefreshUserChartsUseCase implements UseCase<void, Promise<Result<void>>> {
  private syncService: SyncRunner

  constructor(syncService?: SyncRunner) {
    if (syncService) {
      this.syncService = syncService
      return
    }
    const container = InversionContainer.getInstance().getContainer()
    this.syncService = container.get<UserChartSyncService>(InjectionTokens.UserChartSyncService)
  }

  async execute(): Promise<Result<void>> {
    try {
      return await this.syncService.sync()
    } catch (error) {
      return Result.fail(error)
    }
  }
}
